import { render } from "./BaseFooter.vue?vue&type=template&id=1fbb5e5b&scoped=true&ts=true"
import script from "./BaseFooter.vue?vue&type=script&lang=ts"
export * from "./BaseFooter.vue?vue&type=script&lang=ts"

import "./BaseFooter.vue?vue&type=style&index=0&id=1fbb5e5b&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbb5e5b"]])

export default __exports__